/**
 * en-GB messages added by Phase 2 task W12 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w12EnGB = {
    'nav.feedback.report': 'Feedback',
    'rpt.duration.minutes': '{m} min',
    'rpt.duration.hm': '{h} h {m} min',
    'rpt.filter.search': 'Search by name',
    'rpt.filter.site': 'Site',
    'rpt.filter.allSites': 'All sites',
    'rpt.filter.group': 'Group',
    'rpt.filter.allGroups': 'All groups',
    'rpt.filter.status': 'Status',
    'rpt.filter.dates': 'Dates',
    'rpt.status.all': 'All visits',
    'rpt.status.open': 'Still signed in',
    'rpt.status.closed': 'Signed out',
    'rpt.range.needBoth': 'Choose a start and an end date to see the report.',
    'rpt.range.tooLong': 'Choose a range of {days} days or fewer.',
    'rpt.col.name': 'Name',
    'rpt.col.site': 'Site',
    'rpt.col.group': 'Group',
    'rpt.col.host': 'Host',
    'rpt.col.signedIn': 'Signed in',
    'rpt.col.signedOut': 'Signed out',
    'rpt.col.duration': 'Time on site',
    'rpt.col.method': 'Sign-in / sign-out',
    'rpt.history.title': 'History',
    'rpt.history.description': 'Every visit in the dates you choose. Times are shown in each site’s time zone.',
    'rpt.history.table': 'Visit history',
    'rpt.history.count': '{count} visits',
    'rpt.history.protected': 'Protected',
    'rpt.history.stillIn': 'Still in',
    'rpt.flag.offline': 'Offline',
    'rpt.flag.clock_adjusted': 'Time corrected',
    'rpt.flag.merged': 'Merged',
    'rpt.flag.validation_warning': 'Check answers',
    'rpt.flag.auto_signed_out': 'Automatic sign-out',
    'rpt.flag.assumed_in': 'Assumed in',
    'rpt.flag.edited': 'Edited',
    'rpt.flag.overstayed': 'Overstayed',
    'rpt.ts.title': 'Timesheets',
    'rpt.ts.description': 'Hours on site for each person in a group, day by day. Select a block to see or correct that record.',
    'rpt.ts.addRecord': 'Add a record',
    'rpt.ts.tooLong': 'A timesheet can cover {days} days at most.',
    'rpt.ts.summary': '{people} people, {total} in all. Times are {zone}.',
    'rpt.ts.empty': 'Nobody in this group signed in during these dates.',
    'rpt.ts.noRecords': 'No records in these dates.',
    'rpt.ts.total': 'Total {total}',
    'rpt.ts.legend.title': 'Key to the bars',
    'rpt.ts.legend.normal': 'Signed in and out',
    'rpt.ts.legend.edited': 'Times edited',
    'rpt.ts.legend.auto': 'Automatic sign-out',
    'rpt.ts.legend.open': 'Still signed in',
    'rpt.ts.edited': 'edited',
    'rpt.ts.auto': 'automatic sign-out',
    'rpt.ts.open': 'still signed in',
    'rpt.ts.segment': '{site}, {from} to {to}. {notes}',
    'rpt.entry.editTitle': 'Timesheet record for {name}',
    'rpt.entry.addTitle': 'Add a timesheet record',
    'rpt.entry.site': '{site}. Times are {zone}.',
    'rpt.entry.zoneNote': 'Times are {zone}.',
    'rpt.entry.person': 'Person',
    'rpt.entry.choosePerson': 'Choose a person',
    'rpt.entry.siteLabel': 'Site',
    'rpt.entry.date': 'Date',
    'rpt.entry.time': 'Time',
    'rpt.entry.signedIn': 'Signed in',
    'rpt.entry.signedOut': 'Signed out',
    'rpt.entry.stillIn': 'Still signed in',
    'rpt.entry.leaveBlank': 'Clear both sign-out fields to show the person as still signed in.',
    'rpt.entry.reasonLabel': 'Reason',
    'rpt.entry.reasonHint': 'Required. It is kept with the record, together with the original times.',
    'rpt.entry.future': 'That time is in the future.',
    'rpt.entry.order': 'Sign-out must be after sign-in.',
    'rpt.entry.saved': 'Record updated.',
    'rpt.entry.add': 'Add record',
    'rpt.entry.added': 'Record added.',
    'rpt.entry.delete': 'Delete record',
    'rpt.entry.deleted': 'Record deleted.',
    'rpt.entry.deleteNeedsReason': 'Give a reason before deleting.',
    'rpt.entry.membersFailed': 'The list of people could not be loaded.',
    'rpt.entry.history': 'History of this record',
    'rpt.entry.kind.sign_in': 'Signed in',
    'rpt.entry.kind.sign_out': 'Signed out',
    'rpt.entry.kind.edit': 'Edited',
    'rpt.entry.kind.delete': 'Deleted',
    'rpt.entry.by': 'by {name}',
    'rpt.entry.superseded': 'Replaced later',
    'rpt.entry.before': 'Before',
    'rpt.entry.after': 'After',
    'rpt.entry.range': '{from} to {to}',
    'rpt.entry.reason': 'Reason: {reason}',
    'rpt.fb.title': 'Feedback',
    'rpt.fb.description': 'How visitors rated their visit, by site and by host.',
    'rpt.fb.tile.sent': 'Requests sent',
    'rpt.fb.tile.responses': 'Responses',
    'rpt.fb.tile.rate': 'Response rate',
    'rpt.fb.tile.average': 'Average rating',
    'rpt.fb.percent': '{value}%',
    'rpt.fb.bySite': 'By site',
    'rpt.fb.byHost': 'By host',
    'rpt.fb.responses': 'All responses',
    'rpt.fb.noHost': 'No host',
    'rpt.fb.outOf': '{rating} out of 5',
    'rpt.fb.distItem': '{rating} stars: {count}',
    'rpt.fb.col.responses': 'Responses',
    'rpt.fb.col.average': 'Average',
    'rpt.fb.col.spread': 'Ratings 1 to 5',
    'rpt.fb.col.received': 'Received',
    'rpt.fb.col.visitor': 'Visitor',
    'rpt.fb.col.rating': 'Rating',
    'rpt.fb.col.comment': 'Comment',
    'rpt.onsite.title': 'On-site report',
    'rpt.onsite.description': 'Email the list of people still signed in at this site, once a day.',
    'rpt.onsite.enabled': 'Send the on-site report each day',
    'rpt.onsite.time': 'Time to send it',
    'rpt.onsite.timeHint': 'Site time.',
    'rpt.onsite.recipients': 'Send it to',
    'rpt.onsite.recipientsNeeded': 'Add at least one email address.',
    'rpt.onsite.groups': 'Groups to include',
    'rpt.onsite.groupsHint': 'Tick none to include every group at the site.',
    'rpt.onsite.weekdaysOnly': 'Weekdays only',
    'rpt.onsite.sendWhenEmpty': 'Send it even when nobody is on site',
    'rpt.onsite.sendNow': 'Send now',
    'rpt.onsite.saveFirst': 'Save your changes before sending a test.',
    'rpt.onsite.sent': 'Sent to {recipients} recipients. {people} people are on site now.',
    'rpt.feedback.title': 'Visitor feedback',
    'rpt.feedback.description': 'Ask visitors in this group how their visit went, by email after they sign out.',
    'rpt.feedback.enabled': 'Ask for feedback',
    'rpt.feedback.enabledHint': 'Only people with an email address on their visit are asked.',
    'rpt.feedback.delay': 'Send after (minutes)',
    'rpt.feedback.delayHint': 'How long after sign-out the email goes.',
    'rpt.feedback.minDays': 'No more than once every (days)',
    'rpt.feedback.minDaysHint': 'Per email address. 0 means every visit.',
    'rpt.feedback.lowScore': 'Low score is at or below',
    'rpt.feedback.lowScoreHint': 'These ratings can trigger an alert. 0 turns it off.',
    'rpt.feedback.question': 'Question',
    'rpt.feedback.questionHint': 'Leave empty for the standard question.',
    'rpt.feedback.allowComment': 'Let people add a comment',
    'rpt.feedback.subject': 'Email subject',
    'rpt.feedback.wordingHint': 'Leave empty for the standard wording.',
    'rpt.feedback.body': 'Email message',
    'rpt.feedback.bodyHint': 'Leave empty for the standard wording. The rating buttons are added for you.',
};
//# sourceMappingURL=w12.js.map